module.exports = __webpack_public_path__ + "assets/blue-download.d89e589ddd3794fc6ca9076c24a69e30.svg";